/**
 * LocationTabTitle (DNKADM-0230) — a headless component that keeps
 * `document.title` in sync with the **selected service location**.
 *
 * It renders nothing; it exists only to host the effect inside the
 * `LocationProvider` tree (`AppLayout` creates that provider, so the shell
 * itself cannot call `useServiceLocation` directly). The document title is an
 * external system, so an effect is the correct tool here.
 *
 * The effect keys on the selected location's **name**, so switching locations
 * retitles the tab and clearing the selection returns it to the default
 * `"Dink Admin"` (see {@link locationTabTitle}). No cleanup is needed — the
 * next change recomputes from the current selection rather than restoring a
 * stale value.
 */
import { useEffect } from 'react';
import { useServiceLocation } from '@/location/useServiceLocation';
import { locationTabTitle } from '@/utils/locationTabTitle';

export function LocationTabTitle(): null {
  const { selected } = useServiceLocation();
  const name = selected?.name ?? null;

  useEffect(() => {
    document.title = locationTabTitle(name);
  }, [name]);

  return null;
}
